module.exports = __webpack_public_path__ + "img/TipJar.74533271.webp";